var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('img',{attrs:{"src":_vm.icon}}),_c('div',{staticClass:"head-title"},[_vm._v("Welcome to Selflane")]),_c('div',{staticClass:"sl-secondary-text"},[_vm._v("We help local businesses to serve better")]),_c('div',{staticClass:"left-corner"}),_c('div',{staticClass:"right-corner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }